import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ec893b88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "col1 app__controllers" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("iframe", {
  src: "https://ghbtns.com/github-btn.html?user=sedovdmitry&repo=vue3-ts-bookmarks&type=star&count=true&size=large",
  frameborder: "0",
  scrolling: "0",
  width: "170",
  height: "30",
  title: "Star repository Vue 3, Vuex, Typescript"
}, null, -1))
const _hoisted_6 = { class: "col1 margin__top__20" }
const _hoisted_7 = {
  ref: "observer",
  class: "observer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_select = _resolveComponent("my-select")!
  const _component_bookmark_list = _resolveComponent("bookmark-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_my_select, {
            modelValue: _ctx.selectedSort,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedSort) = $event)),
            options: _ctx.sortOptions,
            class: "home__select"
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_Transition, { name: "fade-loading" }, {
            default: _withCtx(() => [
              _createVNode(_component_bookmark_list, {
                class: "bookmarkList",
                bookmarks: this.$store.getters['bookmark/searchedAndSortedBookmarks']
              }, null, 8, ["bookmarks"])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_7, null, 512)
    ])
  ]))
}